import * as React from "react";
import IStaticDataValue from "../../../common/models/IStaticDataValue";
import * as _ from "lodash";
import * as $ from "jquery";
import TextInput from "./TextInput";
import AppUtils from "../utils/AppUtils";
import ToggleButtonList from "./ToggleButtonList";
import {QuestionType} from "../utils/AppConstants";
import LocalStorageUtils from "../utils/LocalStorageUtils";
import {SectionContext} from "../utils/EventTrackerConstants";

export interface CustomSelectProps {
    disabled?: boolean,
    dropdownValues: IStaticDataValue[],
    selectedValue: string,
    defaultValue: string,
    updateDropdownValue: (item: string, key?: string, isSuggestionSelected?: boolean) => void,
    keyName?: string;
    widgetName?: string
    capitalizeInput?: boolean;
    id?: any;
    className?:string;
    validationText?: any;
    suggestions?: IStaticDataValue[];
    selectedSuggestionValue?: string;
}

export interface CustomSelectState {
    isDropdownOpen: boolean,
    focusedOption: number,
    filteredOptions: IStaticDataValue[],
    text: string;
    suggestedItem: string;
    suggestedItemKey: string;
}

class CustomSelect extends React.Component<CustomSelectProps, CustomSelectState> {
    constructor(props: CustomSelectProps) {
        super(props);
        this.state = {
            isDropdownOpen: false,
            focusedOption: null,
            filteredOptions: props.dropdownValues,
            text: "",
            suggestedItem: "",
            suggestedItemKey: ""
        }
    }

    static contextType = SectionContext;

    toggleDropdownVisibility = (flag?: boolean) => {
        let disabled = this.props.disabled !== undefined ? this.props.disabled : false;
        if (!disabled) {
            let currentStatus = flag !== undefined ? flag : !this.state.isDropdownOpen;
            this.setState({
                isDropdownOpen: currentStatus,
                focusedOption: null,
                text: "",
                suggestedItemKey: "",
                suggestedItem: "",
                filteredOptions: this.props.dropdownValues
            })
        }
       /* LocalStorageUtils.setClickEvents({ value: flag, field: this.props.keyName, widget: this.props.widgetName, section: this.context })*/
    }

    handleBlur = (event: any): void => {
        if (_.isEmpty(event.relatedTarget) || $(event.relatedTarget).closest(".custom-select-dropdown-cont").length === 0) {
            this.toggleDropdownVisibility(false)
        }
    }

    onClickHandler = (event: React.MouseEvent<HTMLInputElement>) => {
        this.toggleDropdownVisibility(true);
    }

    onSelect = (option: string) => {
        if (this.props.keyName) {
            LocalStorageUtils.setClickEvents({ value: option, field: this.props.keyName, widget: this.props.widgetName, section: this.context })
        }
        this.props.updateDropdownValue(option, this.props.keyName);
        if (option !== null) this.setState({
            suggestedItemKey: "",
            suggestedItem: "",
            text: "",
            isDropdownOpen: false
        })
        else this.setState({
            filteredOptions: this.props.dropdownValues,
            suggestedItemKey: "",
            suggestedItem: "",
            text: "",
            isDropdownOpen: false
        })
    }

    traverseOptions = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (!(event.keyCode > 64 && event.keyCode < 91) && !(event.keyCode > 47 && event.keyCode < 58) && event.keyCode !== 8 && event.keyCode !== 32) {
            if (event.keyCode === 39) {
                if (this.state.suggestedItemKey !== "") {
                    this.props.updateDropdownValue(this.state.suggestedItemKey, this.props.keyName);
                    this.setState({
                        focusedOption: null,
                        suggestedItem: "",
                        suggestedItemKey: "",
                        isDropdownOpen: false
                    })
                }
            }
            if (event.keyCode === 40) {
                if (_.isNull(this.state.focusedOption)) {
                    if (!this.state.isDropdownOpen) {
                        this.setState({ isDropdownOpen: true })
                    } else {
                        this.setState({ focusedOption: 0 })
                    }
                } else {
                    let focusedOption = this.state.focusedOption === (this.props.dropdownValues.length - 1) ? 0 : this.state.focusedOption + 1;
                    this.setState({ focusedOption })
                }
            } else if (event.keyCode === 38) {
                if (_.isNull(this.state.focusedOption)) {
                    if (this.state.isDropdownOpen) {
                        this.setState({ focusedOption: this.props.dropdownValues.length - 1 })
                    }
                } else {
                    let focusedOption = this.state.focusedOption === 0 ? this.props.dropdownValues.length - 1 : this.state.focusedOption - 1;
                    this.setState({ focusedOption })
                }
            } else if (event.keyCode === 13) {
                if (!_.isNull(this.state.focusedOption)) {
                    let option = this.state.filteredOptions[this.state.focusedOption].internalValue;
                    this.props.updateDropdownValue(option);
                    this.setState({ suggestedItem: "", suggestedItemKey: "", focusedOption: null, isDropdownOpen: false })
                } else {
                    this.setState({ isDropdownOpen: true })
                }
            } else if (event.keyCode === 27) {
                if (this.state.isDropdownOpen) {
                    this.setState({ focusedOption: null, isDropdownOpen: false })
                }
            } else if (event.keyCode === 8) {
                if (!_.isEmpty(this.props.selectedValue)) {
                    this.props.updateDropdownValue(null);
                }
            } else if (event.keyCode === 9) {
                // $(event.target).next(":tabbable").focus();
                $(event.target).focusout();
                if (this.state.isDropdownOpen) {
                    this.setState({ focusedOption: null, isDropdownOpen: false })
                }
                return true;
            }
            event.stopPropagation();
            event.preventDefault();
        }
    }

    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let input = (event.target.value || "").toLowerCase();
        this.props.updateDropdownValue(null, this.props.keyName);
        if (input !== "") {
            let filteredList = this.props.dropdownValues && this.props.dropdownValues.filter(item => item.displayValue.toLowerCase().startsWith(input)) || [];
            if (filteredList.length > 0) {
                this.setState({
                    suggestedItem: filteredList[0].displayValue,
                    suggestedItemKey: filteredList[0].internalValue,
                    text: input,
                    filteredOptions: filteredList,
                    isDropdownOpen: true
                })
            }
        } else {
            this.setState({
                suggestedItem: "",
                text: "",
                filteredOptions: this.props.dropdownValues
            })

        }
    }

    handleSuggestionSelect = (value: string) => {
        LocalStorageUtils.setClickEvents({ value: value, field: this.props.keyName, widget: this.props.widgetName, section: this.context })
        this.props.updateDropdownValue(value, this.props.keyName, true);
    }

    render() {
        let wrapperCls = this.state.isDropdownOpen ? "custom-select with-dropdown" : "custom-select";
        let myInstance = this;
        let selectedClass = !_.isEmpty(this.props.selectedValue) || this.state.text !== "" ? "ta-input-wrapper text-input" : "ta-input-wrapper text-input default-value";
        selectedClass = this.props.disabled !== undefined && this.props.disabled === true ? selectedClass.concat(" disabled") : selectedClass;
        let inputValue = !_.isEmpty(this.props.selectedValue) ? this.props.selectedValue : this.state.text;
        const selectedSuggestion = AppUtils.isDefined(this.props.selectedSuggestionValue) ? [this.props.selectedSuggestionValue] : [];
        return (
            <div className={wrapperCls}>
                {!_.isEmpty(this.props.suggestions) && <div className={"cs-suggestions-container"}>
                    <ToggleButtonList type={QuestionType.BOOLEAN_TOGGLE} listItems={this.props.suggestions} selectedItems={selectedSuggestion} onSelectionChange={this.handleSuggestionSelect}/>
                </div>}
                <div className="ta-cont">
                    <div className="dropdown-cont custom-select-dropdown-cont">
                        <div className={"ta-option default"} onClick={(event) => { myInstance.onSelect(null) }} tabIndex={0}>Select</div>
                        {
                            myInstance.state.isDropdownOpen &&
                            _.map(myInstance.state.filteredOptions, function (option: IStaticDataValue, index: number) {
                                let cssClass = !_.isNull(myInstance.state.focusedOption) && myInstance.state.focusedOption === index ?
                                    `ta-option focused` : `ta-option`;
                                return (
                                    <div className={cssClass} onClick={(event) => { myInstance.onSelect(option.internalValue) }} key={index} tabIndex={0} data-index={option.internalValue}>
                                        {option.displayValue}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={selectedClass}>
                        <TextInput
                            disabled={this.props.disabled}
                            getClassName={this.props.className}
                            onClickHandler={this.onClickHandler}
                            placeholder={this.props.defaultValue}
                            name={"selected-value"}
                            value={inputValue}
                            onBlurHandler={this.handleBlur}
                            onKeyDownHandler={this.traverseOptions} onChange={this.handleChange} onFocusHandler={() => this.toggleDropdownVisibility()} />
                            <TextInput name={"suggested-value"} value={this.state.suggestedItem} placeholder={""} />
                        </div>
                    </div>
                    {
                        !_.isEmpty(this.props.validationText) &&
                        <div className="validation-error">
                            {this.props.validationText}
                        </div>

                    }
                    </div>
        )
    }
}




export default   CustomSelect;